import GrComponentFactory from "../gr_component_factory";
import React from "react";

const MEDIUM_DEVICE_BREAKPOINT = 768;

export default GrComponentFactory.createClass({
  displayName: "FacebookLoginButton",

  getInitialState() {
    return {
      popup: false,
    };
  },

  propTypes: {
    enabled: React.PropTypes.bool,
    facebookRedirectUrl: React.PropTypes.string.isRequired,
    facebookSignInUrl: React.PropTypes.string.isRequired,
    fullWidth: React.PropTypes.bool,
  },

  getDefaultProps() {
    return {
      enabled: false,
      fullWidth: false,
    };
  },

  componentDidMount() {
    this.setState({
      popup: window.innerWidth > MEDIUM_DEVICE_BREAKPOINT, // or smaller
    });
  },

  handleButtonPress() {
    if (this.state.popup && typeof $grfb !== "undefined") {
      $grfb.login({
        redirect: this.props.facebookRedirectUrl,
      });
    } else {
      window.location.assign(this.props.facebookSignInUrl);
    }
  },

  render() {
    if (this.props.enabled && typeof $grfb !== "undefined") {
      return (
        <button className={ `gr-button gr-button--facebook gr-button--auth ${this.props.fullWidth ? "gr-button--fullWidth" : ""}` }
          onClick={ this.handleButtonPress }>
          <div className="gr-mediaFlexbox gr-mediaFlexbox--alignItemsCenter gr-mediaFlexbox--justifyHorizontalContentCenter">
            <div className="gr-mediaFlexbox__media gr-button--facebook__icon" />
            <div className="gr-mediaFlexbox__desc">
              Continue with Facebook
            </div>
          </div>
        </button>
      );
    }
    return (null);
  },
});
